// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tMyZ","rootNoMargin":"styles_rootNoMargin__2BjG-"};